/* Task #9 — mobile swipe gallery on collection product cards.
   Touch swipe + snapping are pure CSS (scroll-snap). This script:
     1) moves the active .pcard__dash to match the image in view (passive scroll
        listener on the track), and
     2) keeps the product link reliable: a clean tap navigates, a swipe does not,
        and modifier-clicks (cmd/ctrl/shift/middle → open in new tab) are left to
        the browser. The track is a scroll container that sits inside the
        <a class="pcard__link"> wrapper, so we navigate explicitly to avoid the
        scroll container swallowing the anchor's activation.
   Only classes are toggled — never inline styles — so this can't collide with the
   data-cascade scroll-reveal in animations.js. Each gallery card is initialised
   directly (the grid is paginated, so the card count per page is small and a few
   passive listeners per card are cheap). On desktop the track is display:contents
   (never scrollable), so the scroll handler self-no-ops; normal clicks still
   navigate and modifier clicks still open new tabs. */
(function () {
  if (window.__pcardGalleryInit) return;
  window.__pcardGalleryInit = true;

  var MOVE_THRESHOLD = 10; // px of pointer travel that counts as a swipe, not a tap

  function initCard(card) {
    if (card.dataset.pcardGalleryInit === '1') return;

    var track = card.querySelector('.pcard__media--gallery .pcard__track');
    var dashes = card.querySelectorAll('.pcard__dash');
    var slides = track ? track.querySelectorAll('.pcard__img') : [];
    if (!track || slides.length < 2 || dashes.length < 2) return;

    card.dataset.pcardGalleryInit = '1';

    var link = card.querySelector('.pcard__link');
    var href = link ? link.getAttribute('href') : null;

    // --- active dash tracking ---
    var ticking = false;
    function sync() {
      ticking = false;
      var width = track.clientWidth;
      if (!width) return; // display:contents (desktop) → not scrollable
      var index = Math.round(track.scrollLeft / width);
      if (index < 0) index = 0;
      if (index > dashes.length - 1) index = dashes.length - 1;
      for (var i = 0; i < dashes.length; i++) {
        dashes[i].classList.toggle('is-active', i === index);
      }
    }
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(sync);
      },
      { passive: true }
    );
    sync();

    // --- tap navigates, swipe doesn't ---
    var startX = 0;
    var startY = 0;
    var moved = false;
    track.addEventListener(
      'pointerdown',
      function (e) {
        startX = e.clientX;
        startY = e.clientY;
        moved = false;
      },
      { passive: true }
    );
    track.addEventListener(
      'pointermove',
      function (e) {
        if (Math.abs(e.clientX - startX) > MOVE_THRESHOLD || Math.abs(e.clientY - startY) > MOVE_THRESHOLD) {
          moved = true;
        }
      },
      { passive: true }
    );
    track.addEventListener('click', function (e) {
      // Let the browser handle "open in new tab" etc.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      // Swipe → suppress navigation.
      if (moved) {
        e.preventDefault();
        return;
      }
      // Clean tap → navigate explicitly (the scroll container can otherwise
      // swallow the anchor's default activation on touch).
      if (href) {
        e.preventDefault();
        window.location.href = href;
      }
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.pcard').forEach(function (card) {
      if (card.dataset.pcardGalleryInit === '1') return;
      if (card.querySelector('.pcard__media--gallery')) initCard(card);
    });
  }

  function start() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-scan when a section re-renders (theme editor, facet/AJAX filtering).
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
